import { getCloseReviewSubmissionPageLink } from '../helper/get-close-review-submission-page-link';

export function setCloseUrlOnFocusedDialog(rootElement: HTMLElement) {
    const focusedDialog = rootElement.querySelector<HTMLElement>('.js_cr_oc-focused-dialog');
    focusedDialog?.setAttribute(
        'close-url',
        getCloseReviewSubmissionPageLink(findProductId(rootElement), findVariationId(rootElement), findReferrer(rootElement))
    );
}

function findProductId(rootElement: HTMLElement) {
    const productId = rootElement.dataset.productId;
    return productId ?? null;
}

function findVariationId(rootElement: HTMLElement) {
    const variationId = rootElement.dataset.variationId;
    return variationId ?? null;
}

function findReferrer(rootElement: HTMLElement) {
    const referrer = rootElement.dataset.referrer;
    return referrer ?? null;
}
